import { render, staticRenderFns } from "./reject-fl223-proposal-button.vue?vue&type=template&id=518d497f&"
import script from "./reject-fl223-proposal-button.vue?vue&type=script&lang=js&"
export * from "./reject-fl223-proposal-button.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/stage-dev2/front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('518d497f')) {
      api.createRecord('518d497f', component.options)
    } else {
      api.reload('518d497f', component.options)
    }
    module.hot.accept("./reject-fl223-proposal-button.vue?vue&type=template&id=518d497f&", function () {
      api.rerender('518d497f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/products/fl223/partials/reject-fl223-proposal-button.vue"
export default component.exports